import callPeerRemoteModule from "../../../core/utils/callPeerRemoteModule";
import React, {useEffect} from "react";
import {useSelector} from "react-redux";


const MovingPart = ({movingPart}) => {
  const [activeButton, setActiveButton] = React.useState(false);
  const connectMode = useSelector(state => state.theme.connectMode);
  const currentCamera = useSelector(state => state.toggle.camera);

  useEffect(() => {
    setActiveButton(false);
  }, [currentCamera.currentCameraType]);


  return (
    <li key={movingPart.title}>
      <button type={"button"} className={activeButton ? "active" : ""}
              onClick={async () => {
                console.log(movingPart.code)
                const peer = await callPeerRemoteModule(connectMode);
                setActiveButton(!activeButton);
                if (peer) {
                  for (let code of movingPart.code) {
                    peer && peer.conn.sendData("anim:event", code);
                  }
                }
              }}>
        {movingPart.title}
      </button>
    </li>
  )
}

export default MovingPart;
